var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { gql } from '@apollo/client';
import { ModalWrapper } from '../../shared';
import { useShiftDetailsModalContentData } from '../../ShiftDetailsModalContent';
import { useAddOpportunityModalContentData } from '../AddOpportunityModalContent';
import { useOpportunityFlowModal } from './useOpportunityFlowModal';
export var OpportunityFlowModalFeature = function (_a) {
    var shiftOpportunity = _a.shiftOpportunity, children = _a.children;
    var _b = useOpportunityFlowModal({
        shiftOpportunity: shiftOpportunity
    }), renderModal = _b.renderModal, setModalContent = _b.setModalContent, setModalError = _b.setModalError, setOnAddShiftConfirmationAnalytics = _b.setOnAddShiftConfirmationAnalytics;
    return (React.createElement(ModalWrapper, { renderModal: renderModal, isList: true }, function (modalWrapperFACParams) { return (React.createElement(React.Fragment, null, children(__assign({ setModalError: setModalError, setModalContent: setModalContent, setOnAddShiftConfirmationAnalytics: setOnAddShiftConfirmationAnalytics }, modalWrapperFACParams)))); }));
};
OpportunityFlowModalFeature.fragments = {
    shiftOpportunity: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment OpportunityFlowModal_ShiftOpportunity on ShiftOpportunity {\n            ...UseAddOpportunityModalContentData_ShiftOpportunity\n            ...UseShiftDetailsModalContentData_ShiftOpportunity\n        }\n\n        ", "\n        ", "\n    "], ["\n        fragment OpportunityFlowModal_ShiftOpportunity on ShiftOpportunity {\n            ...UseAddOpportunityModalContentData_ShiftOpportunity\n            ...UseShiftDetailsModalContentData_ShiftOpportunity\n        }\n\n        ", "\n        ", "\n    "])), useAddOpportunityModalContentData.fragments.shiftOpportunity, useShiftDetailsModalContentData.fragments.shiftOpportunity)
};
var templateObject_1;
